var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7781 10.2218C15.4823 5.92606 8.51752 5.92606 4.22176 10.2218C3.83123 10.6123 3.19807 10.6123 2.80754 10.2218C2.41702 9.8313 2.41702 9.19814 2.80754 8.80761C7.88436 3.7308 16.1155 3.7308 21.1923 8.80761C21.5828 9.19814 21.5828 9.8313 21.1923 10.2218C20.8018 10.6123 20.1686 10.6123 19.7781 10.2218ZM16.9497 13.0503C14.216 10.3166 9.78385 10.3166 7.05018 13.0503C6.65966 13.4408 6.02649 13.4408 5.63597 13.0503C5.24544 12.6597 5.24544 12.0266 5.63597 11.636C9.15069 8.12133 14.8492 8.12133 18.3639 11.636C18.7544 12.0266 18.7544 12.6597 18.3639 13.0503C17.9734 13.4408 17.3402 13.4408 16.9497 13.0503ZM14.1213 15.8787C12.9497 14.7071 11.0502 14.7071 9.87861 15.8787C9.48809 16.2692 8.85492 16.2692 8.4644 15.8787C8.07387 15.4882 8.07387 14.855 8.4644 14.4645C10.417 12.5119 13.5828 12.5119 15.5355 14.4645C15.926 14.855 15.926 15.4882 15.5355 15.8787C15.1449 16.2692 14.5118 16.2692 14.1213 15.8787ZM10.9999 18C10.9999 17.4477 11.4476 17 11.9999 17H12.0099C12.5622 17 13.0099 17.4477 13.0099 18C13.0099 18.5523 12.5622 19 12.0099 19H11.9999C11.4476 19 10.9999 18.5523 10.9999 18Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.f22563c3d9c2d7a9e16585942a02e191.svg";
export { ForwardRef as ReactComponent };